import register from '@kpsys/angularjs-register';
import RecordOperationListItemComponent from './operation/record-operation-list-item.component';
import RecordDataService from './record.data-service';
import ForeignDocumentDataService from './kp-find-in-databases/foreign-document.data-service';
import KpFindInDatabasesComponent from './kp-find-in-databases/kp-find-in-databases.component';
import {KpSelectableRecordCardComponent} from './kp-selectable-record-card/kp-selectable-record-card.component';
import {KpSelectableExemplarCardComponent} from './kp-selectable-exemplar-card/kp-selectable-exemplar-card.component';
import AvailabilityDataService from './availability.data-service';
import ExemplarPlacementDataService from './exemplar-placement.data-service';
import ExemplarPlacementService from './exemplar-placement.service';
import KpExemplarsListComponent from './kp-exemplars-list/kp-exemplars-list.component';
import KpExemplarsComponent from './kp-exemplars/kp-exemplars.component';
import ExemplarService from './exemplar.service';
import KpVolumesComponent from './kp-volumes/kp-volumes.component';
import {VolumeDataService} from './kp-volumes/volume.data-service';
import ExemplarDataService from './exemplar.data-service';
import VolumeService from './kp-volumes/volume.service';
import KpRecordHoldingCreationButtonComponent
    from './kp-record-holding-creation-button/kp-record-holding-creation-button.component';
import RecordService from './record.service';
import {KpSelectableCustomTemplateCardComponent} from './kp-selectable-custom-template-card/kp-selectable-custom-template-card.component';
import KpRatingComponent from './kp-rating/kp-rating.component';
import RatingDataService from './kp-rating/rating.data-service';
import {KpCoverPresenter} from './kp-cover/kp-cover.presenter';
import {KpDocumentMiniPresenter} from './kp-document-mini/kp-document-mini.presenter';
import {CitationDataService} from './kp-citation/citation.data-service';
import {CitationPresenter} from './kp-citation/citation.presenter';

/**
 * @ngdoc module
 * @name uc.record
 * @module uc.record
 *
 * @description
 * Record UC
 */
export default register('uc.record')
    .service(ForeignDocumentDataService.serviceName, ForeignDocumentDataService)
    .service(AvailabilityDataService.serviceName, AvailabilityDataService)
    .service(ExemplarPlacementDataService.serviceName, ExemplarPlacementDataService)
    .service(ExemplarPlacementService.serviceName, ExemplarPlacementService)
    .service(ExemplarDataService.serviceName, ExemplarDataService)
    .service(ExemplarService.serviceName, ExemplarService)
    .service(RecordDataService.serviceName, RecordDataService)
    .service(RecordService.serviceName, RecordService)
    .service(VolumeDataService.serviceName, VolumeDataService)
    .service(VolumeService.serviceName, VolumeService)
    .service(RatingDataService.serviceName, RatingDataService)
    .service(KpCoverPresenter.presenterName, KpCoverPresenter)
    .service(KpDocumentMiniPresenter.presenterName, KpDocumentMiniPresenter)
    .component(RecordOperationListItemComponent.componentName, RecordOperationListItemComponent)
    .component(KpFindInDatabasesComponent.componentName, KpFindInDatabasesComponent)
    .component(KpSelectableRecordCardComponent.componentName, KpSelectableRecordCardComponent)
    .component(KpSelectableExemplarCardComponent.componentName, KpSelectableExemplarCardComponent)
    .component(KpExemplarsListComponent.componentName, KpExemplarsListComponent)
    .component(KpExemplarsComponent.componentName, KpExemplarsComponent)
    .component(KpRecordHoldingCreationButtonComponent.componentName, KpRecordHoldingCreationButtonComponent)
    .component(KpVolumesComponent.componentName, KpVolumesComponent)
    .component(KpSelectableCustomTemplateCardComponent.componentName, KpSelectableCustomTemplateCardComponent)
    .component(KpRatingComponent.componentName, KpRatingComponent)
    .service(CitationDataService.serviceName, CitationDataService)
    .service(CitationPresenter.presenterName, CitationPresenter)
    .name();
